import axios from 'axios';
// config
// ----------------------------------------------------------------------

export const generatedClientResponseInterceptor = (response: any) => response;
// export const generatedClientResponseInterceptor = (response: any) => {
//   if (response.data) {
//     response.data.body = response.data;
//   }
//   return response;
// };

const axiosInstance = axios.create({
  baseURL: '/',
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
